import { cleanNotifications, showNotification } from "@mantine/notifications";
import { axiosPost } from "../../Helpers";

export const addMajor = async (values, setOpened, setUpdate) => {
  cleanNotifications();
  console.log(values);
  axiosPost("major/addMajor", values).then((response) => {
    console.log("major Added", response.data);
    if (!response.data.status) {
      setOpened(false);
      showNotification({
        title: "Error",
        message: `${response.data.message}`,
        color: "red",
      });
    } else {
      setUpdate((prev) => !prev);
      setOpened(false);
      showNotification({
        title: "Success",
        message: `${response.data.message}`,
        color: "green",
      });
    }
  });
};
